(function () {
  // =========================
  // 設定
  // =========================
  const ENABLE_ON_PATHS = ['/cart', '/'];
  const STORAGE_DONE_KEY = 'ac_omikuji_video_done_v2'; 
  const WON_GIFT_KEY = 'ac_omikuji_won_gift_id'; 
  const WON_LABEL_KEY = 'ac_omikuji_won_label'; 
  const SHOW_DELAY = 600;

  const VIDEO_URL =
    'https://cdn.shopify.com/videos/c/o/v/349bf230fe2e4142ba60f20b79af87e3.mp4';

  const POSTER_URL =
    'https://cdn.shopify.com/s/files/1/0791/5077/6611/files/S__68460546.jpg';
    
  const RESULT_IMAGES = {
    '6%OFF':    'https://cdn.shopify.com/s/files/1/0791/5077/6611/files/2026birth6.jpg',
    '10%OFF':   'https://cdn.shopify.com/s/files/1/0791/5077/6611/files/2026birth10.jpg',
    'コースター': 'https://cdn.shopify.com/s/files/1/0791/5077/6611/files/2026-coaster.jpg',
    'ガラス食器': 'https://cdn.shopify.com/s/files/1/0791/5077/6611/files/2026-tableware.jpg',
  };

  const PRIZES = [
    { label: '6%OFF',    weight: 35, code: 'birthday06',  type: 'coupon' },
    { label: 'コースター', weight: 25, variantId: 54960579969315, type: 'gift' },
    { label: 'ガラス食器', weight: 25, variantId: 54960578494755, type: 'gift' },
    { label: '10%OFF',   weight: 15, code: 'birthday10', type: 'coupon' },
  ];

  function getGiftQty(cartTotalCents) {
    if (cartTotalCents >= 12000 * 100) return 2;
    if (cartTotalCents >= 6000  * 100) return 1;
    return 0;
  }

  const T_APPLY = 2200;

  // =========================
  // 期間・ページ判定
  // =========================
  const isEventPeriod = true; 
  if (!isEventPeriod) return;

  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  const isCartPage = path === '/cart';
  const isTopPage = path === '/' || /^\/[a-z]{2}([_-][a-z]{2})?$/i.test(path);

  if (!isCartPage && !isTopPage) return;

  // =========================
  // カート監視・自動同期機能 (Cart Watcher)
  // =========================
  let isSyncing = false;
  async function syncGiftQuantity() {
    if (isSyncing) return;
    const wonId = localStorage.getItem(WON_GIFT_KEY);
    if (!wonId) return;

    try {
      isSyncing = true;
      const res = await fetch('/cart.js?t=' + Date.now());
      const cart = await res.json();
      const cartTotalCents = cart.total_price; 
      const expectedQty = getGiftQty(cartTotalCents);
      
      const existing = cart.items.find(i => i.variant_id == wonId);
      const currentQty = existing ? existing.quantity : 0;

      if (expectedQty !== currentQty) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [wonId]: expectedQty } })
        });
        window.location.reload();
      }
    } catch (e) {
      console.error('Gift Sync Error', e);
    } finally {
      isSyncing = false;
    }
  }

  if (isCartPage) {
    syncGiftQuantity();
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add')) {
        setTimeout(syncGiftQuantity, 600); 
      }
      return response;
    };
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.addEventListener('load', function() {
        if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add'))) {
          setTimeout(syncGiftQuantity, 600);
        }
      });
      origOpen.apply(this, arguments);
    };
  }

  // =========================
  // 実行済みチェック
  // =========================
  let hasDone = false;
  let savedWonLabel = null;
  try {
    hasDone = localStorage.getItem(STORAGE_DONE_KEY) === '1';
    savedWonLabel = localStorage.getItem(WON_LABEL_KEY);
  } catch (e) {}

  // =========================
  // 抽選・カート操作関連
  // =========================
  function weightedPick(items) {
    const total = items.reduce((s, x) => s + (Number(x.weight) || 0), 0);
    let r = Math.random() * total;
    for (const it of items) {
      r -= (Number(it.weight) || 0);
      if (r <= 0) return it;
    }
    return items[items.length - 1];
  }

  async function getCartTotal() {
    const res = await fetch('/cart.js?t=' + Date.now());
    const cart = await res.json();
    return cart.total_price;
  }

  async function addGiftToCart(variantId, qty) {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const existing = cart.items.find(i => i.variant_id == variantId);

    if (existing) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: existing.key, quantity: qty })
      });
    } else {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
    }
  }

  function applyDiscountWithRedirect(code, fromCart) {
    const redirectPath = fromCart ? '/cart' : '/';
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectPath)}`;
  }

  // =========================
  // UI生成
  // =========================
  function buildModal() {
    const overlay = document.createElement('div');
    overlay.id = 'ac-omikuji-overlay';
    overlay.innerHTML = `
      <div id="ac-omikuji-modal" role="dialog" aria-modal="true" aria-label="バースデールーレット動画">
        <div id="ac-omikuji-head">
          <div>
            <p id="ac-omikuji-title">Birthday Lucky Roulette</p>
            <p id="ac-omikuji-sub">ルーレットを回してHAPPYをおすそわけ（1回限り）</p>
          </div>
          <button id="ac-omikuji-close" aria-label="閉じる">×</button>
        </div>

        <div id="ac-omikuji-body">
          <div id="ac-omikuji-stage">
            <div id="ac-omikuji-taparea" class="omikuji-video-wrap" aria-label="動画">
              <video id="ac-omikuji-video" muted loop playsinline webkit-playsinline preload="metadata" poster="${POSTER_URL}"></video>
              <div id="ac-omikuji-blackout" class="omikuji-blackout"></div>
              <div id="ac-omikuji-result-screen" class="omikuji-result-screen" style="display:none;">
                <img id="ac-omikuji-result-img" class="omikuji-result-img" alt="" style="display:none;">
              </div>
            </div>

            <div class="omikuji-cta">
              <button id="ac-omikuji-start" class="omikuji-btn primary">START</button>
              <button id="ac-omikuji-reveal" class="omikuji-btn secondary" style="display:none;">STOP</button>
            </div>

            <div id="ac-omikuji-toast" class="omikuji-toast" style="display:none;" aria-live="polite"></div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    return overlay;
  }

  function closeModal(overlay) {
    overlay?.remove();
  }

  function bindTap(el, handler) {
    if (!el) return;
    el.addEventListener('click', (e) => {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      handler(e);
    });
  }

  // =========================
  // モーダルを開く処理
  // =========================
  function openOmikuji(fromCart, skipToLabel = null) {
    if (document.getElementById('ac-omikuji-overlay')) return;

    const overlay = buildModal();

    const stage = overlay.querySelector('#ac-omikuji-stage');
    const titleEl = overlay.querySelector('#ac-omikuji-title');
    const closeBtn = overlay.querySelector('#ac-omikuji-close');
    const startBtn = overlay.querySelector('#ac-omikuji-start');
    const revealBtn = overlay.querySelector('#ac-omikuji-reveal');
    const tapArea = overlay.querySelector('#ac-omikuji-taparea');
    const video = overlay.querySelector('#ac-omikuji-video');
    const blackout = overlay.querySelector('#ac-omikuji-blackout');
    const resultScreen = overlay.querySelector('#ac-omikuji-result-screen');
    const resultImg = overlay.querySelector('#ac-omikuji-result-img');
    const subEl = overlay.querySelector('#ac-omikuji-sub');
    const toast = overlay.querySelector('#ac-omikuji-toast');

    video.src = VIDEO_URL;

    closeBtn.addEventListener('click', () => closeModal(overlay));
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal(overlay);
    });

    let step = 0;
    let pickedCache = null;

    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.style.display = 'block';
      toast.classList.remove('is-show');
      requestAnimationFrame(() => toast.classList.add('is-show'));
    }

    function renderResult(picked) {
      const imgUrl = RESULT_IMAGES[picked.label];
      if (!imgUrl) return;
      resultImg.src = imgUrl;
      resultImg.alt = picked.label;
      resultImg.style.display = 'block';
    }

    // ★ 獲得済み（2回目以降）の場合の画面表示書き換え
    if (skipToLabel) {
      const picked = PRIZES.find(p => p.label === skipToLabel);
      if (picked) {
        pickedCache = picked;
        step = 2; 
        
        video.style.display = 'none';
        blackout.style.display = 'none';
        startBtn.style.display = 'none';
        revealBtn.style.display = 'none';
        
        stage.classList.add('is-result');
        resultScreen.style.display = 'grid';
        renderResult(picked);
        
        if (titleEl) titleEl.textContent = '獲得済みの特典';
        if (subEl) {
          subEl.textContent = picked.type === 'gift'
            ? '画像をタップでカートを確認する'
            : '画像をタップでお買い物を続ける';
        }
      }
    } else {
      startBtn.style.display = '';
      revealBtn.style.display = 'none';
    }

    async function startPlayback() {
      if (step !== 0) return;
      startBtn.style.display = 'none';
      revealBtn.style.display = '';
      revealBtn.textContent = 'STOP';
      blackout.classList.add('is-hide');
      video.currentTime = 0;
      video.muted = true;

      try {
        await video.play();
      } catch (e) {
        blackout.classList.remove('is-hide');
        startBtn.style.display = '';
        revealBtn.style.display = 'none';
        step = 0;
        alert('動画を再生できませんでした。もう一度お試しください。');
        return;
      }
      step = 1;
    }

    function showResultOnly() {
      if (step !== 1) return;

      const picked = weightedPick(PRIZES);
      pickedCache = picked;

      try {
        localStorage.setItem(STORAGE_DONE_KEY, '1');
        localStorage.setItem(WON_LABEL_KEY, picked.label);
        hasDone = true;
        savedWonLabel = picked.label;
      } catch (e) {}

      try { video.pause(); } catch (e) {}
      video.style.display = 'none';
      blackout.style.display = 'none';
      startBtn.style.display = 'none';
      revealBtn.style.display = 'none';

      stage.classList.add('is-result');
      resultScreen.style.display = 'grid';
      renderResult(picked);

      if (subEl) {
        subEl.textContent = picked.type === 'gift'
          ? '画像をタップで特典を受け取る'
          : '画像をタップで割引を適用';
      }

      step = 2;
    }

    // ★ タップ時の黒い通知（トースト）の文言切り替え
    async function applyFromResultTap() {
      if (step !== 2 || !pickedCache) return;
      step = 3;

      resultScreen.style.pointerEvents = 'none';
      resultImg.style.pointerEvents = 'none';

      const picked = pickedCache;
      const isReapply = !!skipToLabel; 

      if (picked.type === 'gift') {
        try {
          localStorage.setItem(WON_GIFT_KEY, picked.variantId);

          const cartTotal = await getCartTotal();
          const qty = getGiftQty(cartTotal);

          if (qty > 0) {
            // カートへ追加成功時の文言
            const successMsg = fromCart 
              ? (isReapply ? '特典はカートに追加済みです！\nまもなく再読み込みします。' : 'プレゼントをカートに追加しました！\nまもなく再読み込みします。') 
              : (isReapply ? '特典はカートに追加済みです🎁' : 'プレゼントを獲得しました！\nカートに追加されました🎁');
            
            showToast(successMsg);
            await addGiftToCart(picked.variantId, qty);

            setTimeout(() => {
              if (fromCart) window.location.href = '/cart';
              else window.location.reload(); 
            }, T_APPLY);

          } else {
            // 金額不足時の文言
            const underMsg = isReapply
              ? '特典は獲得済みです！\n※6,000円以上のお買い物でカートに自動追加されます🎁'
              : 'プレゼントを獲得しました！\n※6,000円以上のお買い物でカートに自動追加されます🎁';
              
            showToast(underMsg);

            setTimeout(() => closeModal(overlay), T_APPLY);
          }
        } catch (e) {
          console.error('ギフト追加処理エラー', e);
        }

      } else {
        // クーポン時の文言
        const couponMsg = fromCart 
          ? (isReapply ? '割引は適用済みです。\nまもなくカートへ移動します。' : '割引を適用しました。\nまもなくカートへ移動します。') 
          : (isReapply ? '割引は適用済みです！\nこのままお買い物をお楽しみください🛒✨' : '割引を獲得しました！\nこのままお買い物をお楽しみください🛒✨');

        showToast(couponMsg);

        setTimeout(() => {
          applyDiscountWithRedirect(picked.code, fromCart);
        }, T_APPLY);
      }
    }

    function handleAction() {
      if (step === 0) return startPlayback();
      if (step === 1) return showResultOnly();
    }

    bindTap(startBtn, handleAction);
    bindTap(revealBtn, handleAction);
    bindTap(tapArea, handleAction);
    bindTap(resultScreen, applyFromResultTap);
    bindTap(resultImg, applyFromResultTap);
  }

  // =========================
  // 起動条件
  // =========================
  if (isCartPage) {
    if (!hasDone) {
      setTimeout(() => openOmikuji(true), SHOW_DELAY);
    }
    return;
  }

  if (isTopPage) {
    const handleHashTrigger = () => {
      if (window.location.hash === '#omikuji') {
        if (hasDone && savedWonLabel) {
          openOmikuji(false, savedWonLabel);
        } else {
          openOmikuji(false);
        }
        history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    };

    handleHashTrigger();
    window.addEventListener('hashchange', handleHashTrigger);
  }
})();